import { render } from "./AppLoadingDots.vue?vue&type=template&id=128f7d12&scoped=true"
import script from "./AppLoadingDots.vue?vue&type=script&lang=js"
export * from "./AppLoadingDots.vue?vue&type=script&lang=js"

import "./AppLoadingDots.vue?vue&type=style&index=0&id=128f7d12&scoped=true&lang=css"

import exportComponent from "/tmp/build_61b3eac7/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128f7d12"]])

export default __exports__